module.exports = __webpack_public_path__ + "static/media/buildup.16db7cf0.svg";